import * as gridLayout from "./action-type";
import renameActionType from "Store/renameActionType";
renameActionType(gridLayout, "gridLayout");

let defaultState = {
    editable: false,
    draggingItems: {
        from: "",
        data: [],
    },
    initialGroups: [],
    groups: [],
    currEditID: "",
    json: {},
    selectedCards: [],
    updateHomePage: () => { },
    showEmpty: false,
    deduplicateModalVisible: false,
    isDroppable: true,
    margin: 12, //桌面间隔默认12 取值范围[12, 16, 20]
    groupCanDrag: true, //分组是否可拖拽
    appGroupMap: {}, //聚合应用数据
    defaultAppGroupData: {}, //默认聚合应用数据
    draggingAppGroupItem: {}, //拖拽中的聚合应用item
    isShowHelpHint: false, //是否显示帮助信息
    droppedAppGroupItem: {
        id: "",
        data: [],
    },
    isSaveComplete: false, //保存成功标识
    isUpdateLayout: false, //更新布局标识
    siderCollapsed: true, //左栏收起状态
    helpTipVisible: true, //是否显示左侧帮助提示
    saveExternalLinkData: {}, //常用链接数据持久化
    isRespWorkbench: null, //是否职责桌面
    dragOverGroupItem: null, //dragOver的分组
    hasEditingSider: false, // 存在正在编辑的侧边栏
    workbenchConfig: null // 工作台整体配置
};
// 首页表单数据
export const gridLayoutData = (state = defaultState, action = {}) => {
    switch (action.type) {
        //切换编辑状态
        case gridLayout.TOGGLE_EDIT_STATUS:
            const stateObj = { editable: action.data };
            if (!stateObj.editable) {
                if (!state.helpTipVisible) {
                    stateObj.helpTipVisible = true; // 取消编辑之后恢复，以便下次编辑时可以展示
                }
                if (state.hasEditingSider) {
                    stateObj.hasEditingSider = false; // 退出编辑态，置为false
                }
            }
            return { ...state, ...stateObj };
        //设置layouts数据
        case gridLayout.SET_LAYOUTS:
            let newGroupLayouts = JSON.parse(JSON.stringify(state.groups));
            newGroupLayouts[action.data.index].apps = action.data.data;
            return { ...state, ...{ groups: newGroupLayouts } };
        case gridLayout.UPDATE_APP_PROPERTIES:
            const newGroups = _.cloneDeep(state.groups);
            const { groupIndex, id, properties, replace = false } = action.data;
            const groupApps = newGroups[groupIndex].apps;
            const appIndex = groupApps.findIndex(item => item.cardid === id);
            if(appIndex !== -1) {
                // 替换全部字段
                if(replace) {
                    groupApps[appIndex] = properties;
                } else {
                    groupApps[appIndex] = { ...groupApps[appIndex], ...properties };
                }
            }
            return { ...state, ...{ groups: newGroups } };
        //设置正在拖拽的item
        case gridLayout.SET_DRAGGING_ITEMS:
            let newDraggingItems = action.data || {
                from: "",
                data: [],
            }
            return { ...state, ...{ draggingItems: newDraggingItems } };
        case gridLayout.CLEAR_DATA:
            return {
                ...state,
                ...defaultState,
            };
        case gridLayout.UPDATE_SHADOWCARD:
            return { ...state, ...{ shadowCard: action.shadowCard } };
        case gridLayout.UPDATE_GROUP_LIST:
            return { ...state, ...{ groups: action.groups } };
        case gridLayout.UPDATE_CURREDITID:
            return { ...state, ...{ currEditID: action.currEditID } };
        case gridLayout.INIT_GROUPS:
            return { ...state, ...{ initialGroups: action.initialGroups } };
        case gridLayout.JSON:
            return { ...state, ...{ json: action.json } };
        case gridLayout.UPDATE_SELECTED_CARDS:
            return { ...state, ...{ selectedCards: action.selectedCards } };
        case gridLayout.UPDATE_HOMEPAGE:
            return { ...state, ...{ updateHomePage: action.updateHomePage } };
        case gridLayout.SET_EMPTY:
            return { ...state, ...{ showEmpty: action.showEmpty } };
        case gridLayout.TOGGLE_DEDUPLICATE_MODAL:
            return { ...state, ...{ deduplicateModalVisible: action.deduplicateModalVisible } };
        case gridLayout.SET_DROPPABLE:
            return { ...state, ...{ isDroppable: action.isDroppable } };
        case gridLayout.SET_GRID_MARGIN:
            return { ...state, ...{ margin: action.margin } };
        // case gridLayout.SET_GROUP_DRAGABLE:
        //     return { ...state, ...{ groupCanDrag: action.groupCanDrag } };
        case gridLayout.SET_APP_GROUP_DATA:
            let appGroupMap = JSON.parse(JSON.stringify(state.appGroupMap));
            //传对象直接覆盖
            if (Object.prototype.toString.call(action.key) === "[object Object]") {
                appGroupMap = _.cloneDeep(action.key); // 克隆，避免被意外的修改
                const { updateAll } = action.key;
                if (updateAll === false) {
                    delete appGroupMap.updateAll;
                } else if(Object.keys(appGroupMap).length){
                    appGroupMap.updateAll = true; //用来控制是否更新AppGroupAction里的缓存
                }
            } else {
                //传null表示删除
                if (action.data === null) {
                    delete appGroupMap[action.key];
                } else {
                    appGroupMap[action.key] = action.data;
                }
            }
            return { ...state, ...{ appGroupMap } };
        case gridLayout.SET_DRAGGING_APPGROUP_ITEM:
            return { ...state, ...{ draggingAppGroupItem: action.draggingAppGroupItem } };
        case gridLayout.SET_HELP_HINT:
            return { ...state, ...{ isShowHelpHint: action.isShowHelpHint } };
        case gridLayout.SET_DROPPED_ITEM:
            return {
                ...state,
                ...{
                    droppedAppGroupItem: {
                        id: action.id,
                        data: action.data || [],
                        callback: action.callback
                    },
                },
            };
        case gridLayout.SET_DEFAULT_APP_GROUP_DATA:
            return { ...state, ...{ defaultAppGroupData: action.defaultAppGroupData } };
        case gridLayout.SET_SAVE_COMPLETE_FLAG:
            return { ...state, ...{ isSaveComplete: action.isSaveComplete } };
        case gridLayout.UPDATE_LAYOUT_FLAG:
            return { ...state, ...{ isUpdateLayout: action.isUpdateLayout } };
        case gridLayout.SET_SIDER_COLLAPSED:
            return { ...state, ...{ siderCollapsed: action.siderCollapsed } };
        case gridLayout.SET_LEFT_HELPTIP:
            return { ...state, ...{ helpTipVisible: action.helpTipVisible } };
        case gridLayout.IS_RESP_WORKBENCH:
            return { ...state, ...{ isRespWorkbench: action.isRespWorkbench } };
        case gridLayout.SAVE_EXTERNAL_LINK_DATA:
            let newData = {};
            if (action.externalData) {
                newData = { ...state.saveExternalLinkData, ...{ [action.externalData.pk_group_app || action.externalData.cardid]: action.externalData } }
            }
            return { ...state, ...{ saveExternalLinkData: newData } };
        // case gridLayout.SET_DRAGOVER_GROUP:
        //     return { ...state, ...{ dragOverGroupItem: action.dragOverGroupItem } };
        case gridLayout.UPDATE_EDITING_SIDER_STATUS:
            return { ...state, ...{ hasEditingSider: action.hasEditingSider } };
        case gridLayout.SET_WORKBENCH_CONFIG:
            return { ...state, ...{ workbenchConfig: action.workbenchConfig } };
        default:
            return state;
    }
};
